import { CreditKindSchema, CreditExpirationPolicySchema, CreditScheduleSchema } from '@vy/types';
import { ObjectIdSchema } from '@vy/types';
import { isNotEmptyString, oz } from '@vy/utils';

export const CREDIT_PRICE_TYPES = Object.freeze({ OneTime: 'OneTime', Recurring: 'Recurring' });
export const CreditPriceTypeSchema = oz.nativeEnum(CREDIT_PRICE_TYPES);
export type CreditPriceType = oz.infer<typeof CreditPriceTypeSchema>;

export const AddCreditFormSchema = oz.object({
  name: oz.string().min(1, 'Credit name is required'),
  creditTypeId: ObjectIdSchema.refine(isNotEmptyString, 'Pick or create a credit product'),
  creditKind: CreditKindSchema,
  schedule: CreditScheduleSchema,
  priceType: CreditPriceTypeSchema,
  amount: oz.number({ invalid_type_error: 'Amount is required' }).positive('Amount must be greater than 0'),
  expiryDate: oz.date().optional().nullable(),
  expirationPolicy: CreditExpirationPolicySchema.optional().nullable(),
  applyAutomatically: oz.boolean(),
});

export type AddCreditForm = oz.infer<typeof AddCreditFormSchema>;
